import moment from 'moment-timezone';

function nowDate() {
  const now = new Date();
  now.setHours(0);
  now.setMinutes(0);
  now.setSeconds(0);
  now.setMilliseconds(0);
  return now;
}
function dateIsPast(date) {
  if (!date) return true;
  const now = nowDate();
  if (date < now) return true;
  return false;
}
function dateTimeIsPast(dateStr, timezone) {
  const date = moment.tz(dateStr, timezone).toDate();
  if (!date) return true;
  const now = new Date();
  if (date < now) return true;
  return false;
}
function isWeekend(date) {
  return date.getDay() === 0 || date.getDay() === 6;
}
function isInRange(date, selectedRange) {
  if (!selectedRange?.length && !selectedRange?.start) return false;
  const rangeStartMoment = moment(selectedRange.start || selectedRange[0]);
  const rangeEndMoment = moment(selectedRange.end || selectedRange[selectedRange.length - 1]);
  const dateMoment = moment(date);
  return (
    dateMoment.isSame(rangeStartMoment) ||
    dateMoment.isSame(rangeEndMoment) ||
    dateMoment.isBetween(rangeStartMoment, rangeEndMoment)
  );
}
function expandRange(range, includePastDays = false) {
  const { start, end } = range;
  const endMoment = moment(end);
  const nextMoment = moment(start).add(1, 'days');
  const dates = [start];
  while (nextMoment.isBefore(endMoment)) {
    const nextDate = nextMoment.toDate();
    if (includePastDays || !dateIsPast(nextDate)) dates.push(nextDate);
    nextMoment.add(1, 'days');
  }
  return dates;
}

module.exports = {
  nowDate,
  dateIsPast,
  dateTimeIsPast,
  isWeekend,
  isInRange,
  expandRange,
};
